import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Button,
  Nav,
  Table,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import classnames from "classnames"
import { useHistory } from "react-router-dom"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import axios from "axios"
import ReactPaginate from "react-paginate"
import { ToastContainer, toast } from "react-toastify"
import { baseurl, imgUrl } from "Baseurls"

function Ventures() {
  const redirctdashboard = sessionStorage.getItem("dashtype")

  const [activeTab1, setactiveTab1] = useState(
    redirctdashboard == "User" ? "2" : "1"
  )

  const toggle1 = tab => {
    if (activeTab1 !== tab) {
      setactiveTab1(tab)
    }
  }

  const [subdoc, setsubdoc] = useState([])
  const [subdoc1, setsubdoc1] = useState([])
  const history = useHistory()
  const [form1, setform1] = useState([])
  const [form2, setform2] = useState([])

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var datas = data.token

  const [listPerPage] = useState(10)
  const [pageNumber, setPageNumber] = useState(0)
  const [listPerPage1] = useState(10)
  const [pageNumber1, setPageNumber1] = useState(0)

  useEffect(() => {
    getSubDoc()
    getSubUser()
  }, [])

  const getSubDoc = () => {
    var token = datas
    axios
      .post(
        baseurl + "subscribeAdmin/getAll",
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setsubdoc(res.data.subscribeResult)
      })
  }

  const getSubUser = () => {
    var token = datas
    axios
      .post(
        baseurl + "subscribeAdmin/getallusersubscribes",
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setsubdoc1(res.data.subscribeResult)
      })
  }

  const pagesVisited = pageNumber * listPerPage
  const lists = subdoc.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(subdoc.length / listPerPage)
  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  const pagesVisited1 = pageNumber * listPerPage1
  const lists1 = subdoc1.slice(pagesVisited1, pagesVisited1 + listPerPage1)
  const pageCount1 = Math.ceil(subdoc1.length / listPerPage1)
  const changePage1 = ({ selected }) => {
    setPageNumber1(selected)
  }

  const Search = e => {
    const myUser = { ...form1 }
    myUser[e.target.name] = e.target.value
    setform1(myUser)
    const token = datas
    axios
      .post(
        baseurl + "subscribeAdmin/getAll?searchQuery=" + `${e.target.value}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(
        res => {
          if (res.status === 200) {
            setsubdoc(res.data.subscribeResult)
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  const Search1 = e => {
    const token = datas
    const myUser = { ...form2 }
    myUser[e.target.name] = e.target.value
    setform2(myUser)
    axios
      .post(
        baseurl +
          "subscribeAdmin/getallusersubscribes?searchQuery=" +
          `${e.target.value}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(
        res => {
          if (res.status === 200) {
            setsubdoc1(res.data.subscribeResult)
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)

  const redirectdata1 = data => {
    sessionStorage.setItem("subid", data._id)
    history.push("/viewsub")
  }

  const redirectdata = data => {
    sessionStorage.setItem("docid", data.subscriberId)
    history.push("/ViewDoctor")
  }

  const Agentid1 = data => {
    sessionStorage.setItem("userid", data.subscriberId)
    history.push("/ViewUser")
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Allude" breadcrumbItem="Subscribers" />
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <Row>
                    <Col md="4">
                      <Row>
                        <Col md="12">
                          <div className="mt-2">
                            <Nav pills className="navtab-bg nav-justified">
                              <NavItem className="border border-primary rounded m-1">
                                <NavLink
                                  style={{ cursor: "pointer" }}
                                  className={classnames({
                                    active: activeTab1 === "1",
                                  })}
                                  onClick={() => {
                                    toggle1("1")
                                  }}
                                >
                                  Doctor's
                                </NavLink>
                              </NavItem>
                              <NavItem className="border border-primary rounded m-1">
                                <NavLink
                                  style={{ cursor: "pointer" }}
                                  className={classnames({
                                    active: activeTab1 === "2",
                                  })}
                                  onClick={() => {
                                    toggle1("2")
                                  }}
                                >
                                  User's
                                </NavLink>
                              </NavItem>
                            </Nav>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <TabContent activeTab={activeTab1} className="p-3 text-muted">
                    <TabPane tabId="1">
                      <Row>
                        <Col md="12" className="mt-2 text-end mb-3">
                          <div style={{ float: "right" }}>
                            <Input
                              name="search"
                              value={form1.search}
                              onChange={Search}
                              type="search"
                              placeholder="Search..."
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="table-rep-plugin table-responsive">
                        <Table hover className="table table-bordered mb-4">
                          <thead>
                            <tr className="text-center">
                              <th>SlNo</th>
                              <th>Date</th>
                              <th>Ex Date</th>
                              <th>Doc Id</th>
                              <th>Doc Name</th>
                              <th>Plan Name</th>
                              <th>Price</th>
                              <th>Invoice</th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {lists.map((data, key) => (
                              <tr className="text-center" key={key}>
                                <th>{(pageNumber - 1) * 10 + key + 11}</th>
                                <th>{data.startDate}</th>
                                <th>{data.endDate}</th>
                                <th>
                                  <a
                                    onClick={() => {
                                      redirectdata(data)
                                    }}
                                  >
                                    # {data.subscriberNo}
                                  </a>
                                </th>
                                <th>{data.subscriberName}</th>
                                <td>{data.planName}</td>
                                <td> {data.price}</td>
                                <td>
                                  <a
                                    target="blank"
                                    href={imgUrl + data.invoice}
                                  >
                                    <Button
                                      outline
                                      size="sm"
                                      color="primary"
                                      title="Invoice View"
                                    >
                                      <i className="fas fa-eye"></i> View
                                    </Button>
                                  </a>
                                </td>
                                <td>
                                  {data.status == true ? "Active" : "Inactive"}
                                </td>
                                <td>
                                  <Button
                                    size="sm"
                                    className="m-1"
                                    color="warning"
                                    outline
                                    onClick={() => {
                                      redirectdata1(data)
                                    }}
                                    title="View"
                                  >
                                    <i className="fas fa-eye"></i> View
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                        <div
                          className="d-flex mt-3 mb-1"
                          style={{ float: "right" }}
                        >
                          <ReactPaginate
                            previousLabel={"Previous"}
                            nextLabel={"Next"}
                            pageCount={pageCount}
                            onPageChange={changePage}
                            containerClassName={"pagination"}
                            previousLinkClassName={"previousBttn"}
                            nextLinkClassName={"nextBttn"}
                            disabledClassName={"disabled"}
                            activeClassName={"active"}
                            total={lists.length}
                          />
                        </div>
                      </div>
                    </TabPane>
                    <TabPane tabId="2">
                      <Row>
                        <Col md="12" className="mt-2 text-end mb-3">
                          <div style={{ float: "right" }}>
                            <Input
                              name="search"
                              value={form2.search}
                              onChange={Search1}
                              type="search"
                              placeholder="Search..."
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="table-rep-plugin table-responsive">
                        <Table hover className="table table-bordered mb-4">
                          <thead>
                            <tr className="text-center">
                              <th>SlNo</th>
                              <th>Date</th>
                              <th>Expiry Date</th>
                              <th>User Id</th>
                              <th>User Name</th>
                              <th>Plan Name</th>
                              <th>Price</th>
                              <th>Invoice</th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {lists1.map((data, key) => (
                              <tr className="text-center" key={key}>
                                <th>{(pageNumber1 - 1) * 10 + key + 11}</th>
                                <th>{data.startDate}</th>
                                <th>{data.endDate}</th>
                                <th>
                                  <a
                                    onClick={() => {
                                      Agentid1(data)
                                    }}
                                  >
                                    # {data.subscriberNo}
                                  </a>
                                </th>
                                <th>{data.subscriberName}</th>
                                <td>{data.planName}</td>
                                <td> {data.price}</td>
                                <td>
                                  <a
                                    target="blank"
                                    href={imgUrl + data.invoice}
                                  >
                                    <Button
                                      outline
                                      size="sm"
                                      color="primary"
                                      title="Invoice View"
                                    >
                                      <i className="fas fa-eye"></i> View
                                    </Button>
                                  </a>
                                </td>
                                <td>
                                  {data.status == true ? "Active" : "Inactive"}
                                </td>
                                <td>
                                  <Button
                                    size="sm"
                                    className="m-1"
                                    color="warning"
                                    outline
                                    onClick={() => {
                                      redirectdata1(data)
                                    }}
                                    title="View"
                                  >
                                    <i className="fas fa-eye"></i> View
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                        <div
                          className="d-flex mt-3 mb-1"
                          style={{ float: "right" }}
                        >
                          <ReactPaginate
                            previousLabel={"Previous"}
                            nextLabel={"Next"}
                            pageCount={pageCount1}
                            onPageChange={changePage1}
                            containerClassName={"pagination"}
                            previousLinkClassName={"previousBttn"}
                            nextLinkClassName={"nextBttn"}
                            disabledClassName={"disabled"}
                            activeClassName={"active"}
                            total={lists1.length}
                          />
                        </div>
                      </div>
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ToastContainer />
        </div>
      </div>
    </React.Fragment>
  )
}

export default Ventures
